
import wixLocation from 'wix-location';
import wixData from 'wix-data';
let querycategories = wixData.query("Blog/Categories");
let queryPosts = wixData.query("Blog/Posts");
let color1 = "#306CB3"
let id  = ""
let idcat  = ""
$w.onReady(function () {
  
	querycategories
  .find()
  .then( (results) => {
   
      $w("#repeater2").data = results.items
    $w("#repeater2").expand()
  } )





 $w('#myPostPage').getPost()
  .then( (post) => {

    let postid = post._id;
	idcat = post.categories[0];
	id = post._id;


 
if ( post.categories.length===0  ) {
queryPosts
.limit(12)
  .find()
  
  .then( (results) => {
    if(results.items.length > 0) {
      $w("#repeater1").data = results.items
	  $w("#repeater1").expand()
    } 
	
  } )
 	
}else{

queryPosts
.hasSome("categories", [idcat])
  .find()
  .then( (results) => {
    if(results.items.length > 0) {
      $w("#repeater1").data = results.items
	   $w("#repeater1").expand()
    } 
	
  } )
 }





	
   
  } )
 
$w("#repeater2").onItemReady( ($item, itemData, index) => {
 const title = $item("#text163");
 const item = $item("#box216");
 title.text = itemData.label
if (itemData._id ===idcat ) {

	   item.style.backgroundColor = color1
	
}

item.onClick( (event) => {


queryPosts
.hasSome("categories", [itemData._id])
  .find()
  .then( (results) => {
    if(results.items.length > 0) {
      $w("#repeater1").data = results.items
	  $w("#repeater1").expand()
    } 
  } )


	$w("#repeater2").forEachItem( ($item2, itemData2, index2) => {
 const item2 = $item2("#box216");


	   item2.style.backgroundColor = "#FFFFFF"
	


	 
	 } );
	  item.style.backgroundColor = color1





	} );

	 } );







$w("#repeater1").onItemReady( ($item, itemData, index) => {

   
  
  const item = $item("#item");
  const mor = $item("#mor");
   const title = $item("#text13");
   const excerpt = $item("#text15");
   const image = $item("#imageX44");
   if (itemData._id ===id ) {
	   // $item("#box").expand()
	
	
}
excerpt.text = itemData.excerpt
title.text = itemData.title
image.src = itemData.coverImage

  item.onClick( (event) => {

                 
if ( $item("#box").collapsed) {
	  $item("#box").expand()
	   
}else{//$item("#box").collapse()
wixLocation.to(itemData.postPageUrl)

}


} );

 
  


});
});
